import { Navigate } from "react-router";
import { PageContentSkeleton } from "@benchmark/ui/components/atomic";
import { useBandwidthDiagnosticsAccess } from "@/hooks/diagnostics/useBandwidthDiagnosticsAccess";
import type { ReactNode } from "react";

/** Route guard for ICT-professional bandwidth diagnostics. */
export const RequireBandwidthDiagnosticsAccess = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { canAccess, isLoading } = useBandwidthDiagnosticsAccess();

  if (isLoading) {
    return <PageContentSkeleton />;
  }

  if (!canAccess) {
    return <Navigate to="/Patient" replace />;
  }

  return children;
};
